(function () {
  'use strict';

  _.once(function () {
    // fetch info data before start app
    var $q = angular.injector(['ng']).get('$q'),
      $http = angular.injector(['ng']).get('$http'),
      requests = [],
      isLocalDev = _.find(
        ['diviaclocal', '192.168', 'localhost', 'travellocal'],
        function (str) {
          return _.includes(window.location.host, str);
        }
      ),
      isStage = _.find(['travel.padi.comingsoon.rocks'], function (str) {
        return _.includes(window.location.host, str);
      }),
      isDev = _.find(
        ['inprogress.rocks'],
        function (str) {
          return _.includes(window.location.host, str);
        }
      ),
      server = '//travel.padi.com/api/v2/travel/info/',
      menu = '//travel.padi.com/api/v2/travel/menu',
      experimentIdDr = 'thRslaMWT4aqTHA-GF8wkA',
      experimentIdLa = '5c7mihWSQjqquM-eRABC-A';

    if (isLocalDev) {
      server = '//travel.localhost/api/v2/travel/info/';
      menu = '//travel.localhost/api/v2/travel/menu/';
      // experimentId = 'LHyU6NLySDi-lnj1xcRI8Q';
    } else if (isStage) {
      server = '//travel.padi.comingsoon.rocks/api/v2/travel/info/';
      menu = '//travel.padi.comingsoon.rocks/api/v2/travel/menu/';
    } else if (isDev) {
      server = 'https://travel.padi.inprogress.rocks/api/v2/travel/info/';
      menu = 'https://travel.padi.inprogress.rocks/api/v2/travel/menu/';
      // experimentId = 'LHyU6NLySDi-lnj1xcRI8Q';
    }
    var localStorageIsSupported = true;
    if (typeof localStorage === 'object') {
      try {
        localStorage.setItem('localStorage', 1);
        localStorage.removeItem('localStorage');
        localStorageIsSupported = true;
      } catch (e) {
        // Storage.prototype._setItem = Storage.prototype.setItem;
        // Storage.prototype.setItem = function() {};
        // alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        localStorageIsSupported = false;
      }
    }

    if (localStorageIsSupported && localStorage.getItem('testMode') && localStorage.getItem('testMode') === 'test') {
      server = 'https://travel.padi.inprogress.rocks/api/v2/travel/info/';
      menu = 'https://travel.padi.inprogress.rocks/api/v2/travel/menu/';
    }

    requests.push($http.get(server));
    requests.push($http.get(menu));


    window.LANGUAGES = [
      'en',
      'fr',
      'de',
      'es',
      'it',
    ];


    if (!getCookie('travel_language')) {
      var language, langCode;

      if (window.navigator.languages && window.navigator.languages.length) {
        _.each(window.navigator.languages, function (val) {
          langCode = val.split('-')
          if (window.LANGUAGES.indexOf(langCode[0]) !== -1 && !window.requireRedirect) {
            window.requireRedirect = langCode[0];
          }
        });
      } else {
        language = window.navigator.language || window.navigator.userLanguage;
        if (language) {
          langCode = language.split('-')
          
          if (window.LANGUAGES.indexOf(langCode[0]) !== -1) {
            window.requireRedirect = langCode[0]
          }
        }
      }
    }

    var langPrefix = window.location.pathname.match(/^\/[a-z]{2,3}\//),
      lang = 'en';

    if (langPrefix) {
      if (langPrefix[0] === '/ach/') {
        lang = 'ach'
      } else {
        lang = langPrefix[0].substr(1, 2)
      }
    }

    document.documentElement.setAttribute('lang', lang);
    document.body.classList.add('lang-' + lang);

    setCookie('travel_language', lang, {
      path: '/',
      domain: window.location.href.search('padi.com') !== -1 ? '.padi.com' : '.padi.inprogress.rocks',
      expires: 3600 * 24 * 7 /* 7 days */
    });

    window.lang = lang;

    $q.all(requests)
      .then(function (res) {
        if (res.length) {
          angular.element(document).ready(function () {
            var info = res[0].data;
            info.experimentIdLa = experimentIdLa;
            info.experimentIdDr = experimentIdDr;
            angular.module('app').constant('info', info);
            angular.module('app').constant('selectedLanguage', lang);

            if (res[1].data) {
              var destinationsItem = {
                codeName: 'destinations',
                operators: {
                  liveaboards: [],
                  diveResorts: [],
                },
                isShown: true,
                order: 1,
                title: 'Destinations',
              };

              // creating new menu item - Destinations
              menu = _.filter(res[1].data, function (elem) {
                if (elem.destinationLinks) {
                  if (elem.codeName === 'liveaboards') {
                    console.log('la');
                    destinationsItem.operators.liveaboards = elem.destinationLinks;
                    return false;
                  } else if (elem.codeName === 'dive_resorts') {
                    console.log('dr');
                    destinationsItem.operators.diveResorts = elem.destinationLinks;
                    return false;
                  }
                }
                return true;
              });
              console.log(menu);
              // add new destinations item
              menu.unshift(destinationsItem);
              angular.module('app').constant('megaMenu', menu);
            }
            angular.bootstrap(document, ['app']);
            return true;
          });
        }
      });

    function setCookie(name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires == 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;

      for (var propName in options) {
        updatedCookie += '; ' + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
      document.cookie = updatedCookie;
    }

    function getCookie(name) {
      var matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
  })();

})(window);
